/* eslint-disable react/jsx-no-undef */
import React from "react";

// import { useNavigate } from "react-router-dom";

import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import TopLogo from "../../components/layout/TopLogo";
import backgroundSuccess from "../../assets/images/register/bg-success.png";
import correct from "../../assets/images/checkmark.png";
import TransparentButton from "../../components/button/TransparentButton";
import dayjs from "dayjs";
import prizeDefault from '../../assets/images/haier-prize-default-sq.png';

export default function PrizeSuccess() {
    const { state } = useLocation();
    const navigate = useNavigate();
    return (
        <>
            <TopLogo />
            <div
                style={{
                    background: `url(${backgroundSuccess}) no-repeat center center fixed`,
                    minHeight: "calc(100vh - 60px)",
                    padding: "25px",
                    backgroundSize: "cover",
                }}
            >
                <img
                    className="mx-auto mt-[60px]"
                    src={correct}
                    alt="logo"
                    style={{ width: "52px" }}
                />
                <div className="text-white text-center text-[34px] mt-[10px]">
                    รับของรางวัลเรียบร้อย
                </div>
                <div className="text-white text-center text-[24px] mt-[10px]">
                    {state.name}
                </div>


                {state.picture ? (
                    <img
                        className="mx-auto mt-[10px]"
                        src={state.picture}
                        alt="logo"
                        style={{ width: "170px" }}
                    />
                ) : (
                    <img
                        className="mx-auto mt-[10px]"
                        src={prizeDefault}
                        alt="logo"
                        style={{ width: "170px" }}
                    />
                )
                }

                <p className="text-white text-[24px] mt-[30px]">รายละเอียด</p>
                <div className="white-line"></div>
                <div className="mt-[5px] flex justify-between items-start">
                    <p className="text-white text-[16px] whitespace-pre-line leading-[24px]">
                        รหัสรางวัล:
                    </p>
                    <p className="text-white text-[16px]">{state.code}</p>
                </div>
                <div className="flex justify-between items-start">
                    <p className="text-white text-[16px] whitespace-pre-line leading-[24px]">
                        วันที่/เวลาแลกของรางวัล:
                    </p>
                    <p className="text-white text-[16px]">{dayjs(state.getRewardDate, 'YYYY-MM-DD HH:mm:ss').add(7, 'hours').format('DD/MM/YYYY HH:mm:ss')}น.</p>
                </div>
                <div className="">
                    <p className="text-white text-[16px] whitespace-pre-line leading-[24px]">
                        สถานที่จัดส่ง:
                    </p>
                    <p className="text-white text-[16px]">{state.deAddress}</p>
                </div>

                <div className="text-center mt-[50px]">
                    <div className="my-4">
                        <TransparentButton
                            variant="contained"
                            className="w-[70%]"
                            onClick={() => {
                                navigate("/prize");
                            }}
                        >
                            เสร็จสิ้น
                        </TransparentButton>
                    </div>
                </div>
            </div>
        </>
    );
}
